/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftTemplate } from './ShiftTemplate';
import {
    ShiftTemplateFromJSON,
    ShiftTemplateFromJSONTyped,
    ShiftTemplateToJSON,
    ShiftTemplateToJSONTyped,
} from './ShiftTemplate';

/**
 * 
 * @export
 * @interface UpdateShiftTemplateResponse
 */
export interface UpdateShiftTemplateResponse {
    /**
     * 
     * @type {ShiftTemplate}
     * @memberof UpdateShiftTemplateResponse
     */
    data: ShiftTemplate;
}

/**
 * Check if a given object implements the UpdateShiftTemplateResponse interface.
 */
export function instanceOfUpdateShiftTemplateResponse(value: object): value is UpdateShiftTemplateResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateShiftTemplateResponseFromJSON(json: any): UpdateShiftTemplateResponse {
    return UpdateShiftTemplateResponseFromJSONTyped(json, false);
}

export function UpdateShiftTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShiftTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ShiftTemplateFromJSON(json['data']),
    };
}

  export function UpdateShiftTemplateResponseToJSON(json: any): UpdateShiftTemplateResponse {
      return UpdateShiftTemplateResponseToJSONTyped(json, false);
  }

  export function UpdateShiftTemplateResponseToJSONTyped(value?: UpdateShiftTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShiftTemplateToJSON(value['data']),
    };
}

